const isAdmin = (roles = []) => {
  for (let i = 0; i < roles.length; i + 1) {
    if (roles[i].admin_yn) {
      return true;
    }
    return false;
  }
};

export default isAdmin;
